import {main, TypeSat} from '../base-image';

import {buildURL} from './url';

main(TypeSat, {animationStart: 19, animationStop: 23}, {buildURL});
